<template>
  <form-block
    :title="tr('Automation name')"
    :description="description"
  >
    <ui-input
      v-model="entity.name"
      :aria-label="tr('Automation name')"
      :disabled="disabled"
    />
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';

export default {
  name: 'NameBlock',
  mixins: [ RuleFormBlockMixin ],
  props: {
    description: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
  },
  methods: {
    validate() {
      if (!this.entity.name) {
        this.error(this.tr('The {field} field cannot be empty!', { '{field}': this.tr('Name') }));
        return false;
      }

      return true;
    },
  },
};
</script>
